export const FIO_REGEX = /([a-zA-Zа-яА-ЯёЁ-\s])/g;
export const MAX_LENGTH = 50;